import { BcmUserPermission } from '../bcm-user-permission';
import { BcmCapabilityDefinition } from './bcm-capability.types';

/**
 * Fail-open: unbekannte capabilityId → Legacy (Aufruf erlaubt, Rechte prüft weiterhin die API).
 * Autorisierung = ausschließlich bcm_* in der DB, siehe Rule up2boat-ym-capabilities.
 */
export const BCM_CAPABILITIES_REGISTRY: Record<string, BcmCapabilityDefinition> = {
    'shell.avvCheck': {
        id: 'shell.avvCheck',
        permissionsAny: [
            BcmUserPermission.FULL_GRANT,
            BcmUserPermission.AVV_READ,
            BcmUserPermission.AVV_SIGN,
        ],
        loadPolicy: 'onTenantActivate',
        deniedBehavior: 'skip',
        adminHintKey: 'rolesPermissions.capabilities.shellAvvCheck',
    },
    'shell.appInviteFooter': {
        id: 'shell.appInviteFooter',
        permissionsAny: [BcmUserPermission.MAIL_TEMPLATES_READ],
        loadPolicy: 'onTenantActivate',
        deniedBehavior: 'hideNavItem',
        adminHintKey: 'rolesPermissions.capabilities.shellAppInviteFooter',
    },
    'relations.selectList': {
        id: 'relations.selectList',
        permissionsAny: [BcmUserPermission.TENANT_RELATIONS_READ],
        loadPolicy: 'onFeatureOpen',
        deniedBehavior: 'emptyList',
        adminHintKey: 'rolesPermissions.capabilities.relationsSelectList',
    },
    'orders.list': {
        id: 'orders.list',
        permissionsAny: [BcmUserPermission.ORDERS_READ, BcmUserPermission.ORDERS_WRITE],
        loadPolicy: 'onFeatureOpen',
        deniedBehavior: 'emptyList',
        adminHintKey: 'rolesPermissions.capabilities.ordersList',
    },
    'orders.assignees': {
        id: 'orders.assignees',
        permissionsAny: [BcmUserPermission.ORDERS_READ, BcmUserPermission.ORDERS_WRITE],
        loadPolicy: 'onRoute',
        deniedBehavior: 'disableWithHint',
        adminHintKey: 'rolesPermissions.capabilities.ordersAssignees',
    },
    'orders.taskAssigneeLookups': {
        id: 'orders.taskAssigneeLookups',
        permissionsAny: [BcmUserPermission.EMPLOYEES_READ],
        loadPolicy: 'onRoute',
        deniedBehavior: 'disableWithHint',
        adminHintKey: 'rolesPermissions.capabilities.ordersTaskAssigneeLookups',
    },
};

export function getBcmCapabilityDefinition(capabilityId: string): BcmCapabilityDefinition | null {
    return BCM_CAPABILITIES_REGISTRY[capabilityId] ?? null;
}
